import { render, staticRenderFns } from "./MatchMakingModal.vue?vue&type=template&id=2e0a04b9&scoped=true&"
import script from "./MatchMakingModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./MatchMakingModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MatchMakingModal.vue?vue&type=style&index=0&id=2e0a04b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a04b9",
  null
  
)

export default component.exports